import CheckIcon from '@heroicons/react/outline/CheckIcon'
import XIcon from '@heroicons/react/outline/XIcon'
import clsx from 'clsx'
import dayjs from 'dayjs'

import { CustomFieldType } from '@tribeplatform/gql-client/types'
import { Link } from '@tribeplatform/react-ui-kit/Link'

import { SocialMediaView } from './components/SocialMediaView'
import { FieldPrivacyBadges } from './FieldPrivacyBadges'
import { CustomFieldSubtype, getFieldSetting } from './utils'

export const FieldView = ({
  field,
  member,
  highlighted = false,
  preview = false,
  showLabel = false,
}) => {
  if (field?.archived) return null
  let memberField = member?.fields?.find(f => f.key === field.key)
  if (!memberField) memberField = { key: field.key, value: null }
  let { value } = memberField
  if (value) {
    try {
      value = JSON.parse(value)
    } catch (e) {
      logger.error('Error parsing network member field value', e.message)
    }
  }

  if (typeof value === 'undefined' && !preview) {
    return null
  }

  const viewComponent = getFieldSetting(field, 'viewComponent')
  if (viewComponent === 'SocialMedia') {
    if (!preview && !value) return null
    return (
      <div
        className={
          highlighted
            ? 'ring-2 rounded-full ring-offset-surface-50 ring-offset-3 ring-actionPrimary-500'
            : ''
        }
      >
        <SocialMediaView field={field} value={value} />
      </div>
    )
  }

  let isSample = false

  if (field.type === CustomFieldType.ARRAY) {
    if (!value?.length) {
      if (preview) {
        value = ['Sample', 'Value']
        isSample = true
      }
    }
    if (!value) return null

    value = value
      ?.map(option => {
        return option
      })
      ?.join(', ')
  } else if (field.type === CustomFieldType.BOOLEAN) {
    if (preview && typeof value === 'undefined') {
      value = '-'
    } else {
      if (typeof value === 'undefined') return null
      value =
        value === true ? (
          <CheckIcon className="w-4 h-4 text-success-700" />
        ) : (
          <XIcon className="w-4 h-4 text-danger-500" />
        )
    }
  } else if (field.type === CustomFieldType.DATE) {
    if (preview && !value) {
      value = Date.now()
      isSample = true
    }

    if (!value) return null

    if (field?.settings?.view === 'datetime')
      value = dayjs(value).toDate().toLocaleString()
    else value = dayjs(value).toDate().toLocaleDateString()
  } else if (field.type === CustomFieldType.TEXT) {
    if (preview && !value) {
      const subtype = getFieldSetting(field, 'subtype')
      if (subtype === CustomFieldSubtype.URL) value = 'https://example.com'
      else if (subtype === CustomFieldSubtype.EMAIL) value = 'info@example.com'
      else value = 'Sample value'
      isSample = true
    }

    if (!value) return null

    const subtype = getFieldSetting(field, 'subtype')
    if (subtype === CustomFieldSubtype.URL) {
      value = (
        <Link href={value} target="_blank" external variant="neutral">
          {value}
        </Link>
      )
    } else if (subtype === CustomFieldSubtype.EMAIL) {
      value = (
        <Link href={`mailto:${value}`} target="_blank" variant="neutral">
          {value}
        </Link>
      )
    }
  }

  if (!showLabel)
    return <div className="mt-1 text-sm text-basicSurface-900">{value}</div>

  return (
    <div
      className={`sm:col-span-1 ${
        highlighted
          ? 'ring-2 rounded-sm ring-offset-surface-50 ring-offset-8 ring-actionPrimary-500'
          : ''
      }`}
      key={memberField.key}
    >
      <dt className="text-sm font-medium text-basicSurface-500 flex space-x-1 items-center">
        <span>{field.name}</span>
        <FieldPrivacyBadges field={field} />
      </dt>
      <dd
        className={clsx(
          'mt-1 text-sm text-basicSurface-900',
          isSample && 'opacity-50',
        )}
      >
        {value}
      </dd>
    </div>
  )
}
